export default {
  login: {
    username: "E-Mail",
    password: "Passwort",
    signIn: "Anmelden",
    title: "Cube Back-Office",
    subtitle: "Verwalte Spiele- und Casinokonfigurationen.",
    loginFailed: "Username oder Passwort ist falsch."
  },
  common: {
    masterData: "Stammdaten",
    casinos: "Casinos",
    casino: "Casino",
    integrations: "Integrationen",
    integration: "Integration",
    games: "Spiele",
    game: "Spiel",
    bridges: "Bridges",
    manage: "Verwalten",
    versions: "Versionen",
    version: "Version",
    name: "Name",
    user: "Benutzer",
    logout: "Ausloggen",
    bridge: "Bridge",
    adapter: "Adapter",
    properties: "Properties",
    key: "Key",
    value: "Value",
    username: "Username",
    password: "Passwort",
    deleteConfirmation: "Bitte tippen Sie Folgendes in das Eingabefeld um mit dem Löschen fortzufahren: ",
    pleaseChoose: "Bitte auswählen",
    status: "Status",
    save: "Speichern",
    reporting: "Berichte",
    currency: "Währung",
    all: "Alle",
    date: "Datum",
    sum: "Summe",
    dateRange: "Datumsbereich",
    noResults: "Keine Ergebnisse.",
    deactivate: "Deaktivieren",
    activate: "Aktivieren",
    active: "Aktiv",
    valid: "Gültig",
    support: "Support",
    search: "Suchen",
    description: "Beschreibung",
    add: "Hinzufügen",
    delete: 'Löschen',
    yes: 'Ja',
    no: 'Nein',
    start: 'Start',
    end: 'Ende',
    playerId: "Spieler ID",
    gameId: 'Spiel ID',
    totalWagered: 'Einsatz',
    totalWon: 'Gewinn',
    rtp: 'RTP',
    theoreticalRtp: 'Theoretischer RTP',
    happenedAt: 'Geschah am',
    createdAt: 'Erstellt am',
    checkedOn: 'Geprüft am',
    component: 'Komponente',
    hash: 'Hash',
    allowedHashes: 'Zugelassene Hashes',
    result: 'Ergebnis',
    cpv: 'CPV',
    firstPlay: 'Erstes Spiel',
    gameCycles: 'Spiele gespielt',
    gameCyclesGambled: 'Spiele riskiert',
    gameCyclesGambledAndWon: 'Spiele riskiert und gewonnen',
    wageredInOpen: 'Einsatz in offenen Spielen',
    wageredInRefunded: 'Einsatz in erstatteten Spielen',
    wageredInGamble: 'Einsatz in riskierten Spielen',
    wonInGamble: 'Gewinne in riskierten Spielen',
    dataType: "Datentyp"
  },
  masterData: {
    jurisdictions: "Jurisdiktion",
    addJurisdiction: "Gerichtsstand hinzufügen",
    editJurisdiction: "Gerichtsstand bearbeiten",
    deleteJurisdiction: "Delete Jurisdiction",
    deleteJurisdictionDescription: "You can delete only that Jurisdiction which is not in use",
    createJurisdictionSuccess: "Jurisdiction saved successfully",
    editJurisdictionSuccess: "Saved successfully"
  },
  integrations: {
    name: "Integration Name",
    saveSuccess: "Integration wurde gespeichert",
    id: "Integrations-Id",
    idPlaceholder: "Integrations-Id",
    add: "Integration hinzufügen",
    edit: "Integration bearbeiten",
    newIntegrationPlaceholder: "Neue Integration",
    addDescription: "Eine Integration benötigt eine Bridge. Sie ermöglicht die Konfiguration der Spielversionen.",
    delete: "Integration löschen",
    deactivateGameDescription: ["Ein deaktiviertes Spiel verhindert, dass Spieler neue Spielrunden beginnen können.", "Jede offene Spielrunde kann noch zu Ende gespielt werden."],
    activateGameTitle: "Spiel aktivieren",
    activateGameDescription: ["Aktivierte Spiele ermöglichen Spielern neue Spielrunden zu beginnen."],
    gameActivated: "Spiel aktiviert.",
    gameDeactivated: "Spiel deaktiviert.",
    gameAdded: "Spiel wurde hinzugefügt",
    gameRoundValidityPeriod: "Spielrundengültigkeitsdauer",
    gameRoundValidityPeriodHelp: "Die Anzahl der Tage, die es dauert, bis eine offene Spielrunde automatisch erstattet wird.",
    gameActive: "Aktiv",
    gameInactive: "Inaktiv",
    addProperty: "Property hinzufügen",
    pushPageTitle: "Integrations-Konfiguration hochladen",
    pushSuccessful: "Integrations-Konfiguration erfolgreich hochgeladen.",
    pushFailed: "Fehler beim Hochladen der Integrations-Konfiguration",
    defaultCasinoId: "Default Casino ID",
    defaultCasinoIdPlaceHolder: "-",
    bridgeInfo: "Bridge Info"
  },
  casinos: {
    add: "Casino hinzufügen",
    edit: "Casino bearbeiten",
    newCasinoPlaceholder: "Mein neues Casino",
    idPlaceholder: "cf_mynewcasino",
    id: "Casino ID",
    name: "Casino Name",
    addDescription: "Ein Casino benötigt eine Bridge- und Adapterkonfiguration. Es ermöglicht die Konfiguration der möglichen Spielversionen.",
    adapterConfiguration: "Adapterkonfiguration",
    apiUrl: "API URL",
    secret: "Secret",
    key: "Key",
    jurisdictionKey: "Jurisdiktionsschlüssel",
    addProperty: "Property hinzufügen",
    showDevelopStartPage: "Entwicklerstartseite anzeigen",
    saveSuccess: "Casino wurde gespeichert",
    deleteSuccess: "Casino wurde gelöscht",
    delete: "Casino löschen",
    gameAdded: "Spiel wurde hinzugefügt",
    gameRemoved: "Spiel erfolgreich aus dem Casino entfernt",
    password: "Passwort",
    username: "Benutzername",
    pushPageTitle: "Casinokonfiguration hochladen",
    pushSuccessful: "Casinokonfiguration erfolgreich hochgeladen.",
    pushFailed: "Fehler beim Hochladen der Casinokonfiguration",
    sendEventMessages: "Ereignisnachrichten versenden",
    options: "Optionen",
    gameDeactivated: "Spiel deaktiviert.",
    deactivateGameTitle: "Spiel deaktivieren",
    deactivateGameDescription: ["Ein deaktiviertes Spiel verhindert, dass Spieler neue Spielrunden beginnen können.", "Jede offene Spielrunde kann noch zu Ende gespielt werden."],
    gameActivated: "Spiel aktiviert.",
    activateGameTitle: "Spiel aktivieren",
    activateGameDescription: ["Aktivierte Spiele ermöglichen Spielern neue Spielrunden zu beginnen."],
    gameActive: "Aktiv",
    gameInactive: "Inaktiv",
    createIntegrationOptionSuccess: "Integrationsoption wurde gespeichert.",
    integrationOption: "Integrationsoption",
    integrationOptions: "Integrationsoptionen",
    createCasinoIntegrationOption: "Integrationsoption hinzufügen",
    editCasinoIntegrationOption: "Integrationsoption bearbeiten",
    editIntegrationOptionSuccess: "Integrationsoption wurde gespeichert.",
    selectIntegrationOption: "Integrationsoption auswählen",
    deleteIntegrationOptionSuccess: "Integrationsoption wurde gelöscht.",
    deleteCasinoIntegrationOption: "Integrationsoption löschen",
    deleteCasinoIntegrationOptionDescription: "Du kannst eine Integrationsoption nur löschen, wenn sie von keinem Casino verwendet wird.",
    gameRoundValidityPeriod: "Spielrundengültigkeitsdauer",
    maxRTP: "Max RTP",
    maxRTPHelp: "The RTP for game win. If not provided then default value will be used",
    gameRoundValidityPeriodHelp: "Die Anzahl der Tage, die es dauert, bis eine offene Spielrunde automatisch erstattet wird.",
    settings: "Einstellungen"
  },
  games: {
    add: "Spiel hinzufügen",
    edit: "Spiel bearbeiten",
    addDescription1: "Ein Spiel besteht aus einem Namen und einer eindeutigen Kennung.",
    addDescription2: "Es bündelt mehrere Spielversionen, die wiederum für eine Casino-Konfiguration verwendet werden können.",
    newGamePlaceholder: "Mein neues Spiel",
    gameId: "Spiele ID",
    gameIdPlaceholder: "cf_meinneuesspiel",
    saveSuccess: "Spiel wurde gespeichert",
    deleteSuccess: "Spiel wurde gelöscht",
    delete: "Spiel löschen",
    theoreticalReturnToPlayer: 'Theoretischer RTP',
    theoreticalReturnToPlayerPlaceholder: '0,00'
  },
  bridges: {
    add: "Bridge hinzufügen",
    edit: "Bridge bearbeiten",
    addDescription: "Eine Bridge ist ein Endpunkt, der Casino- und Spielekonfigurationen akzeptiert. Es stellt den Clients die konfigurierten Spiele zur Verfügung und verarbeitet die Anforderungen der Casinos.",
    newBridgePlaceholder: "Meine neue Bridge",
    routerUrlPlaceholder: "https://my-new-bridge.com",
    routerUrl: "Router Url",
    saveSuccess: "Bridge wurde gespeichert",
    deleteSuccess: "Bridge wurde gelöscht",
    delete: "Bridge löschen",
    addProperty: "Property hinzufügen"
  },
  versions: {
    frontendUrl: "Frontend-URL",
    backendUrl: "Backend-URL",
    historyUrl: "History-URL",
    add: "Version hinzufügen",
    addDescription: "Eine Spielversion beinhaltet die URLs, an denen ein Client auf seine Frontend- und Backend-Ressourcen zugreifen kann.",
    edit: "Version bearbeiten",
    versionPlaceholder: "v1.51",
    frontendUrlPlaceholder: "https://your-frontend-cdn.com",
    backendUrlPlaceholder: "https://your-backend.com",
    historyUrlPlaceholder: "https://your-history-cdn.com",
    saveSuccess: "Version wurde gespeichert",
    deleteSuccess: "Version wurde gelöscht",
    delete: "Version löschen",
    missingProperties: "Fehlende Properties",
    missingPropertiesExist: "Es gibt nicht gesetzte Properties!",
    selectJurisdiction: "Jurisdiktion auswählen",
    betSizes: "Einsatzgrößen",
    betSizesPlaceHolder: "Geben Sie eine Wettgröße ein"
  },
  reporting: {
    revenues: "Umsätze",
    winnings: "Gewinne",
    stake: "Einsätze",
    ggr: "Umsatz",
    rtp: "RTP",
    playerHistory: "Spielerhistorie",
    playerId: "Spieler ID",
    playerIdPlaceholder: "Trage eine Spieler ID ein",
    timestamp: "Zeitstempel",
    game: "Spiel",
    gameRoundId: "Spielrunden ID",
    gameRoundCredit: "Spielrundengewinn",
    credit: "Gewinn",
    debit: "Einsatz",
    reports: "Reports",
    downloadGamePerformanceReport: "Spielperformance-Report herunterladen",
    downloadGamePerformanceReportDescription: "Erstellt eine CSV-Datei, die die Gesamtsumme der Wetteinsätze und Gewinne des Spiels in der ausgewählten Zeitperiode enthält.",
    download: "Herunterladen",
    downloadAuditLog: "Audit-Log herunterladen",
    downloadAuditLogDescription: "Eine CSV-Datei mit allen Konfigurationsänderungen.",
    downloadCPVReport: "CPV-Report herunterladen",
    downloadCPVReportDescription: "Eine CSV-Datei mit den Ergebnissen der täglichen Authentifizierungsprüfungen.",
    downloadFailedBookingsReport: "Fehlgeschlagene Buchungen-Report herunterladen",
    downloadFailedBookingsReportDescription: "Eine CSV-Datei mit allen fehlgeschlagenen Buchungen.",
    downloadSignificantEventsReport: "Wichtige Ereignisse herunterladen",
    downloadSignificantEventsReportDescription: "Alle manuellen Änderungen am System werden als wichtiges Ereignis protokolliert.",
    downloadGamePlayHistory: "Spielhistorie herunterladen",
    downloadGamePlayHistoryDescription: "Die Spielhistorie enthält alle Spielrunden eines Spielers.",
    gamePerformanceReports: "Spielperformance-Reports",
    significantEvents: 'Wichtige Ereignisse',
    createSignificantEvent: 'Wichtiges Ereignis anlegen',
    createSignificantEventSuccess: 'Wichtiges Ereignis wurde angelegt.',
    cpvChecks: 'Überprüfungen',
    checkComponents: 'Komponenten überprüfen',
    checkComponentsDescription: 'Prüft, ob alle Komponenten in einer erlaubten Version laufen. Dieser Vorgang dauert ein paar Sekunden.',
    triggerCPVCheckSuccessful: 'Komponenten wurden überprüft.',
    downloadReport: 'Download Report',
    casinoPerformanceReport: "Casino Performance Report",
    gamesPlayed: "Games Played",
    bet: "Bet"
  },
  cpv: {
    allowedHashes: 'Zugelassene Hashes',
    allowedHash: 'Zugelassener Hash',
    addAllowedHash: 'Hash zulassen',
    addAllowedHashSuccessful: 'Hash erfolgreich zugelassen.',
    removeAllowedHashSuccessful: 'Hash erfolgreich entfernt.',
    component: 'Komponente',
    hash: 'Hash',
  },
  support: {
    openGameRounds: "Offene Spielrunden",
    playerId: "Spieler ID",
    gameName: "Spiel",
    creationDate: "Start",
    player: 'Spieler',
    debit: 'Einsatz',
    credit: 'Gewinn',
    totalWin: 'Gesamtgewinn',
    refundable: 'Erstattungsfähig',
    notRefundable: 'Nicht erstattungsfähig',
    refundOpenGameRound: 'Offene Spielrunde erstatten',
    refundOpenGameRoundDescription: ['Mit einer Rückerstattung wird dem Spieler sein Einsatz zurückerstattet.', 'Wenn der Spieler bereits Gewinne erzielt hat, ist eine Rückerstattung nicht mehr möglich.'],
    enterGameRoundId: 'Gib die Spielrunden ID ein.',
    refund: 'Erstatten',
    refundSuccess: "Offene Spielrunde wurde erstattet.",
  },
  report: {
    error: {
      noData: 'Keine Daten gefunden.'
    }
  },
  backOffice: {
    reporting: {
      noConnection: 'Reporting-Service antwortet nicht.'
    }
  },
  errors: {
    jurisdiction: {
      error: {
        nameAlreadyTaken: "Der Name wird bereits verwendet."
      }
    },
    game: {
      error: {
        gameIdAlreadyInUse: "Die angegebene Game ID ist schon in Verwendung."
      }
    },
    integration:{
      error: {
        casinosBoundToIntegration: "To delete integration first unbound casinos"
      }
    },
    casino: {
      error: {
        casinoIdAlreadyTaken: "Die angegebene Casino ID ist schon in Verwendung.",
        configIsNotApplicableToSelectedAdapter: "Die angegebene Adapter-Konfiguration kann nicht auf den gewählten Adapter angewendet werden.",
        noBridgeConfigured: "Es ist keine Bridge konfiguriert.",
        gameIsAlreadyAssigned: "Das Spiel ist schon dem Casino zugewiesen.",
        integrationOptionInUse: "Integrationsoption wird von einem Casino verwendet.",
        jurisdictionInUse: "Die Jurisdiktion wird von einem Casino verwendet.",
        casinoIdIsDefault: "Dieses Casino ist der Default von einer Integration."
      },
    },
    casinoIntegrationOption: {
      error: {
        nameAlreadyTaken: 'Der Name wird bereits verwendet.'
      }
    },
    gameVersion :{
      error: {
        versionAlreadyTaken: "Die angegebene Spieleversion ist schon in Verwendung."
      }
    }
  }
}
